import { Component, Input } from '@angular/core';
import { NgClass, TitleCasePipe } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TimePeriodPipe } from '../../../core/pipes/time-period.pipe';
import { Agent } from '../../../domain/interfaces/agents';

@Component({
  selector: 'app-agent-card',
  templateUrl: './agent-card.component.html',
  styleUrls: ['./agent-card.component.scss'],
  imports: [NgClass, IonicModule, TitleCasePipe, TimePeriodPipe],
})
export class AgentCardComponent {
  @Input({ required: true }) agent!: Agent;

  calcIcon() {
    const status = this.agent.CurrentEvent.Status.Item.Icon;
    return `assets/icon/${status}.svg`;
  }
}
